<template>
  <div class="topick-header" v-if="info && Object.keys(info).length">
    <template v-if="type === 1">
      <!-- 专题讲座 -->
       <div class="topic-title">当前查询专题讲座</div>
       <div class="content">
        <div class="item"><div class="item-label">讲座主题：</div><div class="item-value">{{ info.lectureName }}</div></div>
        <div class="item"><div class="item-label">授课老师：</div><div class="item-value">{{ info.teacher }}</div></div>
        <div class="item"><div class="item-label">授课老师职务：</div><div class="item-value">{{ info.teacherUnitPosition }}</div></div>
        <div class="item"><div class="item-label">讲座时间：</div><div class="item-value">{{ info.lectureDateStr }}</div></div>
        <div class="item"><div class="item-label">学时：</div><div class="item-value">{{ info.lectureHours }}</div></div>
        <div class="item"><div class="item-label">主办单位：</div><div class="item-value">{{ info.organizer }}</div></div>
        <div class="item"><div class="item-label">讲座地点：</div><div class="item-value">{{ info.lecturePlace }}</div></div>
       </div>
    </template>
    <template v-if="type === 2">
      <!-- 理论 -->
       <div class="topic-title">当前查询理论中心组学习</div>
       <div class="content">
        <div class="item"><div class="item-label">学习名称：</div><div class="item-value">{{ info.lectureName }}</div></div>
        <div class="item"><div class="item-label">学习时间：</div><div class="item-value">{{ info.lectureDateStr }}</div></div>
        <div class="item"><div class="item-label">学时：</div><div class="item-value">{{ info.lectureHours }}</div></div>
        <div class="item"><div class="item-label">学习单位：</div><div class="item-value">{{ info.organizer }}</div></div>
        <div class="item"><div class="item-label">学习地点：</div><div class="item-value">{{ info.lecturePlace }}</div></div>
       </div>
    </template>
    <template v-if="type === 3">
      <!-- 其他培训 -->
       <div class="topic-title">当前查询其他集中培训</div>
       <div class="content">
        <div class="item"><div class="item-label">培训名称：</div><div class="item-value">{{ info.lectureName }}</div></div>
        <div class="item"><div class="item-label">培训时间：</div><div class="item-value">{{ info.lectureDateStr }}</div></div>
        <div class="item"><div class="item-label">学时：</div><div class="item-value">{{ info.lectureHours }}</div></div>
        <div class="item"><div class="item-label">培训单位：</div><div class="item-value">{{ info.organizer }}</div></div>
        <div class="item"><div class="item-label">培训地点：</div><div class="item-value">{{ info.lecturePlace }}</div></div>
       </div>
    </template>
    

  </div>
</template>
<script>

export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang='scss' scoped>
.topick-header {
  margin-bottom: 12px;
  .topic-title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin-bottom: 12px;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    .item {
      display: inline-flex;
      text-align: left;
      font-size: 14px;
      margin-right: 18px;
      margin-bottom: 12px;
      .item-label { 
        flex-shrink: 0;
        font-weight: bold;
        color: #000;
      }

    }
  }
}
</style>